// extracted by mini-css-extract-plugin
export default {"selectGroup":"SelectSecondaryAndCrashCourseBatch_selectGroup__cpOfj"};